import { render, staticRenderFns } from "./MenuBarTabs.vue?vue&type=template&id=04f9cf95&"
import script from "./MenuBarTabs.vue?vue&type=script&lang=js&"
export * from "./MenuBarTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports